module.exports = __webpack_public_path__ + "9785d3cc07c406821804857a40d40745.png";